import Vue from 'vue';
import {
    rtdbPlugin
} from 'vuefire';
import VueTheMask from 'vue-the-mask';
import StarRating from 'vue-star-rating'
import App from './App.vue';
import router from './router';
import VModal from 'vue-js-modal';
import VueHtmlToPaper from 'vue-html-to-paper';

import VueCroppie from 'vue-croppie';
import FunctionalCalendar from 'vue-functional-calendar';
import 'croppie/croppie.css'

Vue.config.productionTip = false

const options = {
    name: '_blank',
    specs: [
        'fullscreen=yes',
        'titlebar=yes',
        'scrollbars=yes'
    ],
    styles: [
        'https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css',
        'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css'
    ]
}

Vue.use(rtdbPlugin);
Vue.use(VueTheMask);
Vue.use(VModal);
Vue.component('star-rating', StarRating);
Vue.use(VueCroppie);
Vue.use(VueHtmlToPaper, options);
Vue.use(FunctionalCalendar, {
    monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
    dayNames: ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab', 'Dom']
});

new Vue({
    router,
    el: '#app',
    render: h => h(App),
    data: {
        user: null,
        configs: null,
        user_data: null,
        drivers: null
    }
});